module.exports = __webpack_public_path__ + "img/plus-circle-dotted.5a55b7c8.svg";